import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import en from './locales/en.json'
import ro from './locales/ro.json'

import reducers from './redux/reducers'
import sagas from './redux/sagas'

export default {
  name: 'people',
  menu: [
    {
      title: <FormattedMessage id="people.menu.title" />,
      key: 'people',
      url: '/people',
      icon: 'icmn icmn-user',
      roles: ['business'],
    },
  ],
  routes: [
    {
      path: '/people',
      async lazy() {
        const Comp = await import('./pages')
        return { Component: Comp.default }
      },
      exact: true,
    },
    {
      path: '/people/:id',
      async lazy() {
        const Comp = await import('./pages/details')
        return { Component: Comp.default }
      },
      exact: true,
    },
  ],
  locales: {
    en,
    ro,
  },
  reducers,
  sagas,
}

export { load as loadPeople } from './redux/list/actions'
export { default as PersonStatus } from './components/Status'
export { fullName } from './utils'
